<template>
  <div class="flex flex-col items-center w-full px-3" style="max-width: 430px;">
    <!-- Heading -->
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
      <rect x="1" y="1" width="42" height="42" rx="11" stroke="white" stroke-width="2"/>
      <path d="M30 18.2V25.8H32V18.2H30ZM27.8 28H16.2V30H27.8V28ZM14 25.8V18.2H12V25.8H14ZM16.2 16H27.8V14H16.2V16ZM16.2 28C15.6235 28 15.2512 27.9992 14.9678 27.9761C14.6962 27.9539 14.5955 27.9162 14.546 27.891L13.638 29.673C14.0164 29.8658 14.4096 29.9371 14.805 29.9694C15.1886 30.0008 15.6565 30 16.2 30V28ZM12 25.8C12 26.3435 11.9992 26.8114 12.0306 27.195C12.0629 27.5904 12.1342 27.9836 12.327 28.362L14.109 27.454C14.0838 27.4045 14.0461 27.3038 14.0239 27.0322C14.0008 26.7488 14 26.3765 14 25.8H12ZM14.546 27.891C14.3579 27.7951 14.2049 27.6421 14.109 27.454L12.327 28.362C12.6146 28.9265 13.0735 29.3854 13.638 29.673L14.546 27.891ZM30 25.8C30 26.3765 29.9992 26.7488 29.9761 27.0322C29.9539 27.3038 29.9162 27.4045 29.891 27.454L31.673 28.362C31.8658 27.9836 31.9371 27.5904 31.9694 27.195C32.0008 26.8114 32 26.3435 32 25.8H30ZM27.8 30C28.3436 30 28.8114 30.0008 29.195 29.9694C29.5904 29.9371 29.9836 29.8658 30.362 29.673L29.454 27.891C29.4045 27.9162 29.3038 27.9539 29.0322 27.9761C28.7488 27.9992 28.3766 28 27.8 28V30ZM29.891 27.454C29.7951 27.6421 29.6422 27.7951 29.454 27.891L30.362 29.673C30.9265 29.3854 31.3854 28.9265 31.673 28.362L29.891 27.454ZM32 18.2C32 17.6565 32.0008 17.1886 31.9694 16.805C31.9371 16.4096 31.8658 16.0164 31.673 15.638L29.891 16.546C29.9162 16.5955 29.9539 16.6962 29.9761 16.9678C29.9992 17.2512 30 17.6235 30 18.2H32ZM27.8 16C28.3766 16 28.7488 16.0008 29.0322 16.0239C29.3038 16.0461 29.4045 16.0838 29.454 16.109L30.362 14.327C29.9836 14.1342 29.5904 14.0629 29.195 14.0306C28.8114 13.9992 28.3436 14 27.8 14V16ZM31.673 15.638C31.3854 15.0735 30.9265 14.6146 30.362 14.327L29.454 16.109C29.6422 16.2049 29.7951 16.3579 29.891 16.546L31.673 15.638ZM14 18.2C14 17.6235 14.0008 17.2512 14.0239 16.9678C14.0461 16.6962 14.0838 16.5955 14.109 16.546L12.327 15.638C12.1342 16.0164 12.0629 16.4096 12.0306 16.805C11.9992 17.1886 12 17.6565 12 18.2H14ZM16.2 14C15.6565 14 15.1886 13.9992 14.805 14.0306C14.4096 14.0629 14.0164 14.1342 13.638 14.327L14.546 16.109C14.5955 16.0838 14.6962 16.0461 14.9678 16.0239C15.2512 16.0008 15.6235 16 16.2 16V14ZM14.109 16.546C14.2049 16.3579 14.3579 16.2049 14.546 16.109L13.638 14.327C13.0735 14.6146 12.6146 15.0735 12.327 15.638L14.109 16.546ZM30.3668 14.8624L22.6332 21.1898L23.8997 22.7378L31.6332 16.4103L30.3668 14.8624ZM21.3668 21.1898L13.6332 14.8624L12.3668 16.4103L20.1003 22.7378L21.3668 21.1898ZM22.6332 21.1898C22.2649 21.4912 21.7351 21.4912 21.3668 21.1898L20.1003 22.7378C21.2054 23.6419 22.7946 23.6419 23.8997 22.7378L22.6332 21.1898Z" fill="white"/>
    </svg>
    <BaseText type="heading" size="md" class="text-white mt-5">
      Check Your Inbox
    </BaseText>
    <!-- Subheading -->
    <BaseText v-if="subheading?.length" type="body" size="md" class="text-neutral-alpha-650 mt-2 text-center">
      {{ subheading }}
    </BaseText>
    <!-- Resend Button (with timer) -->
    <button class="mt-4 underline transition-colors" 
    :class="canResend ? 'text-neutral-alpha-700 hover:text-white' : 'text-neutral-alpha-400 cursor-default'" 
    :disabled="!canResend" @click="attemptResend">
      <BaseText type="body" size="sm">
        Resend {{ resendText }}{{ !canResend ? ` in ${formattedTimer}` : '' }}
      </BaseText>
    </button>
    <!-- Mail Platform Action Buttons -->
    <div class="w-full grid grid-cols-2 gap-2.5 mt-12">
      <button v-for="(platform, index) in mailPlatforms" :key="`open-action-${platform.name}`" 
      class="mail-button w-full flex justify-center items-center gap-1 px-2.5 py-2"
      :class="index === 0 ? 'col-span-2' : ''"
      @click="platform.action()">
        <img :src="platform.img" style="width: 25px; height: 25px;" />
        <BaseText type="heading" size="sm" class="text-white px-1.5">
          Open {{ platform.name }}
        </BaseText>
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'EmailSentDirections',
  props: {
    toEmail: {
      type: String,
      required: true
    },
    subheading: {
      type: String,
      default: ''
    },
    resendText: {
      type: String,
      default: 'email'
    }
  },
  data () {
    const mailPlatforms = [
      { 
        name: 'Gmail', 
        img: require('../../assets/icons/mailers/gmail.png'),
        action: () => this.openMailPlatform('Gmail')
      },
      { 
        name: 'Outlook', 
        img: require('../../assets/icons/mailers/outlook.png'),
        action: () => this.openMailPlatform('Outlook')
      },
      { 
        name: 'Yahoo', 
        img: require('../../assets/icons/mailers/yahoo.png'),
        action: () => this.openMailPlatform('Yahoo')
      },
      { 
        name: 'Proton', 
        img: require('../../assets/icons/mailers/proton.png'),
        action: () => this.openMailPlatform('Proton')
      },
      { 
        name: 'iCloud', 
        img: require('../../assets/icons/mailers/icloud.png'),
        action: () => this.openMailPlatform('iCloud')
      }
    ]
  
    return {
      mailPlatforms,

      // Resent countdown state
      secondsLeft: 120,
      timerId: null,
      canResend: false
    }
  },
  mounted () {
    this.startCountdown()
  },
  beforeDestroy () {
    if (this.timerId) clearInterval(this.timerId)
  },
  computed: {
    formattedTimer () {
      return moment.utc(this.secondsLeft * 1000).format('m:ss')
    }
  },
  methods: {
    attemptResend () {
      if (!this.canResend) return
      this.$emit('resend')
      this.startCountdown()
    },
    openMailPlatform (platform) {
      const fromSegment = encodeURIComponent('noreply@notifications.foreplay.co')
      const toSegment = encodeURIComponent(this.toEmail ?? '0')
      let url = ''
      switch (platform) {
        case 'Gmail':
          url = `https://mail.google.com/mail/u/${toSegment}/#search/from%3A${fromSegment}+in%3Aanywhere+newer_than%3A1h`
          break
        case 'Outlook':
          url = toSegment ? `https://outlook.live.com/mail/?login_hint=${toSegment}` : 'https://outlook.live.com/mail/'
          break
        case 'Yahoo':
          url = `https://mail.yahoo.com/d/search/keyword=from%3A${fromSegment}`
          break
        case 'Proton':
          url = `https://mail.proton.me/u/0/all-mail#from=${fromSegment}`
          break
        case 'iCloud':
          url = 'https://www.icloud.com/mail/'
      }
      window.open(url, '_blank')
    },
    startCountdown () {
      this.canResend = false
      this.secondsLeft = 120

      if (this.timerId) clearInterval(this.timerId)

      // tick every second
      this.timerId = setInterval(() => {
        if (this.secondsLeft > 0) {
          this.secondsLeft--
        } else {
          this.canResend = true
          clearInterval(this.timerId)
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
.mail-button {
  background-color: transparent;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.16);
  border-radius: 10px;
  transition: background-color 100ms ease-in-out, box-shadow 100ms ease-in-out;
}
.mail-button:hover {
  background-color: rgba(255, 255, 255, 0.12);
  box-shadow: none;
}
</style>